import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'components/Accordion';
import Button from 'components/DesignSystem/Button';
import { store } from 'redux/store';
import {
  resetCP,
  selectDVCPMATrackingForecastSubpage,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import useChartRequestTrigger from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useChartRequestTrigger';
import useSavePreference from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useSavePreference';
import useApplyOpenDefaults from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useApplyOpenDefaults';
import FormModal from 'components/PreferenceModals/FormModal';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import { useClosure } from 'utils/hooks';
import Preferences from './Preferences';
import Group from './Group';
import Location from './Location';
import MultiGroup from './MultiGroup';
import MultiLocation from './MultiLocation';
import TimeFrequencies from './TimeFrequencies';
import Variables from './Variables';
import ForecastDate from './ForecastDate';
import Rounds from './Rounds';
// import InclusionCheckboxes from './InclusionCheckboxes';

export default function TrackingForecastDetailedViewControlPanel() {
  const subpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const triggerRequest = useChartRequestTrigger();
  // Preenche a seleção default e auto-consulta ao abrir cada modo (#1822, Área 3).
  useApplyOpenDefaults();
  const clearSelection = useCallback(() => {
    store.dispatch(resetCP());
  }, []);
  const {
    showConfirmationModal,
    setShowConfirmationModal,
    showErrorModal,
    setShowErrorModal,
    errorMessage,
    showFormModal,
    setShowFormModal,
    valid,
    isLoading,
    onNameChange,
    handleSubmit,
    // disabled: saveDisabled,
  } = useSavePreference();

  return (
    <div>
      <ConfirmationModal
        open={showConfirmationModal}
        closing={useClosure(setShowConfirmationModal, false)}
      />
      <ErrorModal
        open={showErrorModal}
        closing={useClosure(setShowErrorModal, false)}
        message={errorMessage}
      />
      <FormModal
        show={showFormModal}
        onHide={useClosure(setShowFormModal, false)}
        valid={valid}
        isLoading={isLoading}
        onNameChange={onNameChange}
        handleSubmit={handleSubmit}
      />
      <Accordion defaultActiveKey="0">
        <Preferences />
        {(subpage === 'locations') && (
        <>
          <MultiGroup />
          <MultiLocation />
          <TimeFrequencies />
          <Variables />
          <ForecastDate />
        </>
        )}
        {(subpage === 'rounds') && (
        <>
          <Group />
          <Location />
          <TimeFrequencies />
          <Variables />
          <Rounds />
        </>
        )}
        <Button
          className="w-100 mt-5"
          onClick={useClosure(setShowFormModal, true)}
        >
          Salvar nova preferência
        </Button>
        <Button
          className="w-100 mt-1"
          onClick={triggerRequest}
          disabled={triggerRequest === undefined}
        >
          Realizar consulta
        </Button>
        <Button
          type="secondary"
          className="w-100 mt-1"
          onClick={clearSelection}
        >
          Limpar gráfico
        </Button>
      </Accordion>
    </div>
  );
}
